module.exports = require("core-js/modules/es.function.bind.js");